import { Suspense } from "react";
import { lazyWithRetry } from "@circle-react/helpers/lazyRetry";
import { PageLoader } from "@circle-react/pages/PageLoader";

const AffiliatesSettingsComponent = lazyWithRetry(
  () =>
    import(
      /* webpackChunkName: "AffiliatesSettingsPage" */ "@circle-react/components/SettingsApp/PaywallsAffiliates/PaywallsAffiliatesSettings"
    ),
);

export const AffiliatesSettingsPage = () => (
  <Suspense fallback={<PageLoader />}>
    <AffiliatesSettingsComponent />
  </Suspense>
);
